import { Fit } from 'types/fit'
import { updateFit, UpdateFitBody } from '@api/fit'
import { setCookie } from '@helpers/session'
import {
  getUserEmail,
  getCustomerId,
  getUserPseudoTokenCookie
} from '@helpers/session/user'
import { identify } from '@helpers/analytics'
import { COOKIE_EXPIRE_1_YEAR } from '@consts/index'
import trackError from '@helpers/trackError'
import { getAnalyticsCountryCode } from '@helpers/env'
import { setStoredValue } from '@helpers/hooks/useStorage'

export async function updateCustomerFit(fitSelection: Fit, method: string) {
  const customerId = getCustomerId()
  const userEmail = getUserEmail()
  const userPseudoToken = getUserPseudoTokenCookie()

  if (userPseudoToken) {
    const payload: UpdateFitBody = {
      token: userPseudoToken,
      method,
      storeLocation: getAnalyticsCountryCode(),
      fit: {
        top: {
          size: fitSelection.size,
          cut: fitSelection.cut,
          length: fitSelection.length
        },
        bottom: {
          waist: `${fitSelection.waist}`,
          build: fitSelection.build,
          leg: `${fitSelection.leg}`
        }
      }
    }

    if (userEmail) {
      payload.email = userEmail
    }

    if (customerId) {
      payload.customerId = customerId
      identify(customerId, fitSelection)
    }

    try {
      await updateFit(payload)
      const fit = JSON.stringify(fitSelection)

      setCookie('saved_fit', fit, COOKIE_EXPIRE_1_YEAR, true)
      setStoredValue('sessionStorage', 'filters', fitSelection)
    } catch (error) {
      trackError(new Error('Failed to update customer Fit'), {
        error: error as Error
      })
      throw error
    }
  }
}
